import {FC, useState} from 'react'

type Props = {
  data: any
  currentLetter: any
  handleCurrentLetter: any
  handleCurrentTab: any
  buttons: any
  disabledTab: boolean
}

const TabStatusLayout: FC<Props> = ({
  data,
  currentLetter,
  handleCurrentLetter,
  handleCurrentTab,
  buttons,
  disabledTab,
}) => {
  const [isActive, setIsActive] = useState('')

  const handleClick = (value: any) => {
    handleCurrentTab(value)
    setIsActive(value)
  }

  const handleShowLetter = (letter: any, btnText: string) => {
    let text = ''
    if (btnText?.includes('TTD')) {
      text = 'SAYA MENYETUJUI KETENTUAN DI ATAS'
    }

    handleCurrentLetter(letter, text, true)
  }

  // fw-semibold
  return (
    <div className='mt-10'>
      <div className='d-flex justify-content-between align-items-center flex-wrap'>
        {/* <!-- Tab Filter --> */}
        <div className='d-flex align-items-center gap-4' style={{cursor: 'pointer'}}>
          {data?.map((item: any, index: number) => {
            const isDisabled = disabledTab === true
            const isSelected = isActive === item?.key

            return (
              <div
                key={index}
                className={`border-2 pb-1 ${
                  isSelected && !isDisabled
                    ? 'text-primary fw-semibold border-primary border-bottom border-2'
                    : ''
                }`}
                style={{pointerEvents: isDisabled ? 'none' : 'auto'}}
                onClick={() => !isDisabled && handleClick(item?.key)}
              >
                {item?.name} <span className='fw-bold'>{item?.value}</span>
              </div>
            )
          })}
        </div>
        
        {/* <div className='d-flex align-items-center gap-4' style={{cursor: 'pointer'}}>
          {data?.map((item: any, index: any) => {
            return (
              <div
                key={index}
                className={`border-2 pb-1 ${
                  isActive == item?.key
                    ? 'text-primary fw-semibold border-primary border-bottom border-2'
                    : ''
                }`}
                onClick={() => handleClick(item?.key)}
              >
                {item?.name} <span className='fw-bold'>{item?.value}</span>
              </div>
            )
          })}
        </div> */}

        {/* <!-- Tombol Aksi --> */}
        <div className='d-flex gap-2 mt-2 mt-sm-0'>
          {buttons?.map((item: any, index: any) => {
            if (!item?.name) {
              return
            }

            return (
              <button
                key={index}
                className='btn btn-sm text-white d-flex align-items-center px-3'
                style={{background: item?.color}}
                onClick={() => handleShowLetter(item?.key, item?.name)}
              >
                <i className={`${item?.icon} me-2 text-white`}></i> {item?.name}
              </button>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default TabStatusLayout
